import { render, staticRenderFns } from "./EmailConfirm.vue?vue&type=template&id=1987d4e6&scoped=true&"
import script from "./EmailConfirm.vue?vue&type=script&lang=js&"
export * from "./EmailConfirm.vue?vue&type=script&lang=js&"
import style0 from "./EmailConfirm.vue?vue&type=style&index=0&id=1987d4e6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1987d4e6",
  null
  
)

export default component.exports